import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils.js";

const baseUrl = "/api/sif/semeRazredcevalec";

export const getSeedDiluterTypes = createAsyncThunk(
  "seedDiluter/getAll",
  async ({ filter }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        { page: 0, size: 1000 },
        filter
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const thunks = [getSeedDiluterTypes];

const seedDiluterSlice = createSlice({
  name: "seedDiluter",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSeedDiluterTypes.fulfilled, (state, action) => {
      state.list = action.payload?.content || [];
    });

    handleLoadingAndErrorState(builder, thunks);
  },
});

export default seedDiluterSlice.reducer;
